import React from "react";

export default function ProgressIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M1 11L4.5 7l3 3 5-6"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        fill="none"
      ></path>
    </svg>
  );
}
